import { hasLocizeTranslation } from 'lib/utils/locize'

const labels = {
  heading: ['Shipping to', 'จัดส่งไปยัง', 'Pengiriman ke'],
  destination: [
    'Choose destination',
    'เลือกประเทศปลายทาง',
    'Pilih negara tujuan',
  ],
  change: ['Change', 'เปลี่ยน', 'Ubah'],
  market: [
    'Change country / region',
    'เปลี่ยนประเทศ / ภูมิภาค',
    'Ubah negara / wilayah',
  ],
  delivery: ['Delivery', 'การจัดส่ง', 'Pengiriman'],
  estimate: [
    'Estimated delivery',
    'ระยะเวลาจัดส่งโดยประมาณ',
    'Estimasi pengiriman',
  ],
  fees: [
    'View delivery fees and conditions',
    'ดูค่าจัดส่งและเงื่อนไข',
    'Lihat biaya dan ketentuan pengiriman',
  ],
  deliveryUnknown: [
    'Choose a destination to see its delivery policy',
    'เลือกประเทศปลายทางเพื่อดูนโยบายการจัดส่ง',
    'Pilih negara tujuan untuk melihat kebijakan pengiriman',
  ],
  timingUnknown: [
    'See the local delivery policy for timing',
    'ดูระยะเวลาจัดส่งในนโยบายของประเทศปลายทาง',
    'Lihat waktu pengiriman dalam kebijakan setempat',
  ],
  shippingPolicy: [
    'Full delivery policy',
    'นโยบายการจัดส่งฉบับเต็ม',
    'Kebijakan pengiriman lengkap',
  ],
  returns: ['Returns', 'การคืนสินค้า', 'Pengembalian'],
  exchanges: ['Exchanges', 'การเปลี่ยนสินค้า', 'Penukaran'],
  eligibility: [
    'Check this item’s eligibility and return conditions',
    'ตรวจสอบสิทธิ์และเงื่อนไขการคืนสินค้านี้',
    'Periksa kelayakan dan ketentuan pengembalian produk ini',
  ],
  nonReturnable: [
    'This item is non-returnable',
    'สินค้านี้ไม่สามารถคืนได้',
    'Produk ini tidak dapat dikembalikan',
  ],
  returnPolicy: [
    'Full returns policy',
    'นโยบายการคืนสินค้าฉบับเต็ม',
    'Kebijakan pengembalian lengkap',
  ],
  exchangePolicy: [
    'Full exchange policy',
    'นโยบายการเปลี่ยนสินค้าฉบับเต็ม',
    'Kebijakan penukaran lengkap',
  ],
  partner: [
    'Partner shipping and return conditions apply',
    'ใช้เงื่อนไขการจัดส่งและคืนสินค้าของพาร์ทเนอร์',
    'Ketentuan pengiriman dan pengembalian mitra berlaku',
  ],
  partnerPolicy: [
    'View partner policy',
    'ดูนโยบายของพาร์ทเนอร์',
    'Lihat kebijakan mitra',
  ],
  preorder: [
    'Pre-order: standard delivery estimates do not apply',
    'สินค้าพรีออเดอร์: ไม่ใช้ระยะเวลาจัดส่งมาตรฐาน',
    'Pre-order: estimasi pengiriman standar tidak berlaku',
  ],
  comingSoon: [
    'Coming soon: delivery timing is not yet available',
    'สินค้าเร็ว ๆ นี้: ยังไม่มีกำหนดการจัดส่ง',
    'Segera hadir: waktu pengiriman belum tersedia',
  ],
  additionalServices: [
    'More shopping benefits',
    'สิทธิประโยชน์เพิ่มเติม',
    'Manfaat belanja lainnya',
  ],
}

export const policyFallback = (key, language = 'en') => {
  const locale = language.toLowerCase().split('-')[0]
  const index = { th: 1, id: 2 }[locale] || 0
  return labels[key]?.[index] || ''
}

export default function policyCopy(t, key, language) {
  return hasLocizeTranslation(
    t,
    `PDP_DELIVERY_POLICY_${key.toUpperCase()}`,
    policyFallback(key, language),
  )
}
